export async function loadListRequest(request, onSuccess, onFailure) {
  try {
    const response = await request;
    onSuccess(response.data);
    return true;
  } catch (error) {
    onFailure(error);
    return false;
  }
}
